export const PAYROLL_EMPLOYEE_NEWLY_ADDED = 'PAYROLL_EMPLOYEE_NEWLY_ADDED'
export const PAYROLL_EMPLOYEE_NEWLY_ADDED_PENDING = 'PAYROLL_EMPLOYEE_NEWLY_ADDED_PENDING'
export const PAYROLL_EMPLOYEE_NEWLY_ADDED_FULFILLED = 'PAYROLL_EMPLOYEE_NEWLY_ADDED_FULFILLED'
export const PAYROLL_EMPLOYEE_NEWLY_ADDED_REJECTED = 'PAYROLL_EMPLOYEE_NEWLY_ADDED_REJECTED'
